<template>
  <div class="login">
    <div class="content-box">
      <router-link class="logo" to="/"
        ><img src="~img/account/logo.png" alt=""
      /></router-link>
      <div class="formWrap">
        <div class="item border-item clearfix">
          <img class="fl" src="~img/account/icon_phone@2x.png" alt="" />
          <input
            v-model="loginValue.account"
            class="fl"
            @keyup="isCanClick"
            type="text"
            placeholder="请输入手机号"
          />
        </div>
        <div class="item border-item clearfix">
          <img class="fl" src="~img/account/icon_code@2x.png" alt="" />
          <input
            class="fl code-input"
            v-model="loginValue.code"
            type="text"
            placeholder="请输入验证码"
          />
          <button
            v-if="isclick"
            :class="{ fr: true, 'code-btn': true, blue: isblue }"
            @click="getMCode"
          >
            获取验证码
          </button>
          <button v-if="!isclick" class="fr code-btn">
            重新发送 ({{ timecount }}s)
          </button>
        </div>
        <div class="item noneitem">
          <button @click="submitLogin" class="submit-btn">登录</button>
        </div>
        <div class="item clearfix">
          <div class="fl clearfix">
            <div class="check fl" @click="chooseCheck">
              <img v-if="checkValue" src="~img/account/option2@2x.png" alt="" />
              <img v-else src="~img/account/option3@2x.png" alt="" />
            </div>
            <p class="fl">记住我</p>
          </div>
        </div>
      </div>
    </div>
    <loginelse></loginelse>
  </div>
</template>

<script>
import {
  isMobile,
  encryptStr,
  isNull,
  setCookie,
  getCookie,
  delCookie
} from "utils/core/kernel";
import { getCode, phonelogin } from "apiurl/user";
export default {
  data() {
    return {
      checkValue: true,
      loginValue: {
        account: "",
        code: ""
      },
      timer: null,
      isclick: true,
      timecount: 60,
      isblue: false
    };
  },
  created() {
    this.$nextTick(() => {
      if (getCookie("maccount")) {
        this.loginValue.account = getCookie("maccount");
        if (isMobile(this.loginValue.account)) {
          this.isblue = true;
        }
      }
    });
  },
  methods: {
    chooseCheck() {
      this.checkValue = !this.checkValue;
    },
    // 登录
    submitLogin() {
      if (isNull(this.loginValue.account) || isNull(this.loginValue.code)) {
        this.Toast({
          message: "手机号和验证码不能为空~",
          duration: 2000,
          position: "top"
        });
      } else if (!isMobile(this.loginValue.account)) {
        this.Toast({
          message: "请输入正确的手机号~",
          duration: 2000,
          position: "top"
        });
      } else {
        phonelogin({
          code: this.loginValue.code,
          account: encryptStr(this.loginValue.account)
        })
          .then(res => {
            if (res.success) {
              if (this.checkValue) {
                setCookie("maccount", this.loginValue.account, 7);
              } else {
                delCookie("maccount");
              }
              this.$store.dispatch("saveInfo", res.data);
              if (this.$route.query.redirect) {
                this.$router.replace(this.$route.query.redirect);
              } else {
                this.$router.replace("/");
              }
            } else {
              if (res.code == 20001) {
                this.$router.replace("/");
              }
            }
          })
          .catch(() => {});
      }
    },
    // 获取验证码
    getMCode() {
      if (isNull(this.loginValue.account)) {
        this.Toast({
          message: "手机号不能为空~",
          duration: 2000,
          position: "top"
        });
      } else if (!isMobile(this.loginValue.account)) {
        this.Toast({
          message: "请输入正确的手机号~",
          duration: 2000,
          position: "top"
        });
      } else {
        getCode({
          mobile: encryptStr(this.loginValue.account)
        }).then(coderes => {
          if (coderes.success) {
            this.Toast({
              message: "短信已发送到您的手机！",
              position: "top",
              duration: 2000
            });
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.timecount = TIME_COUNT;
              this.isclick = false;
              this.timer = setInterval(() => {
                if (this.timecount > 1 && this.timecount <= TIME_COUNT) {
                  this.timecount--;
                } else {
                  this.isclick = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      }
    },
    isCanClick() {
      if (isMobile(this.loginValue.account)) {
        this.isblue = true;
      } else {
        this.isblue = false;
      }
    }
  }
};
</script>
<style>
.content-box .formWrap .item .blue {
  color: #2e93f3;
}
</style>

<style lang="stylus" scoped></style>
